// removed by extract-text-webpack-plugin
module.exports = {"base":"Counter_base--O8CYJ","current":"Counter_current--OXHbm","divider":"Counter_divider--1kugS","total":"Counter_total--3Ct-K","reset":"Counter_reset--2djyi","icon":"Counter_icon--20C09"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-mt-bootstrap/lib/components/Counter/Counter.css
// module id = 1768
// module chunks = 16